import { useState } from "react";
import PageHeader from "../-components/PageHeader";
import PopupForm, { PopupFormProps } from "./PopupForm";
import { RouteTypes } from "hooks/utils/util";
import Seo from "components/Seo";

export default function ConsolePopupCreate({ type }: { type: RouteTypes }) {
    const initialForm = {
        category: "",
        idx: null,
        vTitle: "",
        vPopSizeW: "300",
        vPopSizeH: "400",
        vPopX: "550",
        vPopY: "250",
        cViewYN: "N",
        cTodayYN: "Y",
        cPvL: "L",
        vContent: "",
    };
    const [form, setForm] = useState<PopupFormProps>(initialForm);

    return (
        <>
            <Seo type="console" pageTitle="팝업등록" />
            <div className="flex-1 flex flex-col overflow-hidden max-h-[100dvh]">
                <PageHeader category="사이트관리" title="팝업등록" />
                <div className="flex-1 bg-[#F7F6FB] flex overflow-hidden">
                    <div className=" px-[40px] py-[28px] w-full overflow-auto">
                        <div className="bg-white rounded-[20px] py-[36px] px-[40px] min-w-[800px]">
                            <PopupForm type={type} form={form} setForm={setForm} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
